import { render, staticRenderFns } from "./dividendAgreement.vue?vue&type=template&id=6ab53672&scoped=true&"
import script from "./dividendAgreement.vue?vue&type=script&lang=js&"
export * from "./dividendAgreement.vue?vue&type=script&lang=js&"
import style0 from "./dividendAgreement.vue?vue&type=style&index=0&id=6ab53672&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab53672",
  null
  
)

export default component.exports